import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationType } from '../../enum/notification-type.enum';
import { NotificationService } from 'src/app/service/notification.service';
import { forkJoin, Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ResponseData } from 'src/app/models/commission/response-data.model';
import { Buttons } from 'src/app/home/table/Buttons';
import { Totals } from 'src/app/home/table/Totals';
import { CommissionSummaryService } from 'src/app/service/commission-summary.service';
import { UploadJsonModel } from 'src/app/models/commissionsummary/upload-json.model';
import { CommSummaryModel } from 'src/app/models/commissionsummary/commsummary.model';
import { WorkFlowMessageModel } from 'src/app/models/commissionsummary/workflowmessage.model';
import { UploadJsonHeadersModel } from 'src/app/models/commissionsummary/upload-json-headers.model';
import { GlobalService } from 'src/app/service/global.service';
import { NgForm } from '@angular/forms';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { ApprovalFlowService } from 'src/app/admin-portal/approval-flow-models/approval-flow.service';
import { MissingDisputesModel } from 'src/app/models/commission/missingdisputes.model';
import { ManageUserService } from 'src/app/service/manage-user.service';
import { KpimasterService } from 'src/app/service/kpimaster.service';
import { Kpimaster } from 'src/app/models/commission/kpimaster.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { MissingDisputesService } from 'src/app/service/missingdisputes.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-search-reports-get',
  templateUrl: './search-reports-get.component.html',
  styleUrls: ['./search-reports-get.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class SearchReportsGetComponent implements OnInit {
  //[x: string]: any;
  public commSummaryModel = new CommSummaryModel();
  public commSummary_Model = new CommSummaryModel();
  public uploadJsonHeadersModel = new UploadJsonHeadersModel();
  public workFlowMessageModel = new WorkFlowMessageModel();

  public missingDisputesModel = new MissingDisputesModel();
  public missingDisputesModel1 = new MissingDisputesModel();
  public missingModels: MissingDisputesModel[] = [];
  public kpis: Kpimaster[];
  public filterKPiData: Kpimaster[] = [];
  public vkpiid: string = "";
  public recordType: string = "";
  public checkedactive: boolean = false;
  public excelDataList: any;

  public mySalesChannelSet = new Set<string>();
  public columnsData: any;
  public ordersTableColumns: TableColumn[];
  public ordersTableColumns2: TableColumn[];
  public buttons: Buttons[];
  public totals: Totals[];
  public jsonListData: UploadJsonModel[] = [];
  public headersData: UploadJsonHeadersModel[];
  public buttonsData: UploadJsonHeadersModel[];
  public calcRunningStatus: UploadJsonHeadersModel[];
  public supStatus: UploadJsonHeadersModel[];
  public pageNameList: UploadJsonHeadersModel[];
  public headersData1: UploadJsonHeadersModel[];
  public buttonsData1: UploadJsonHeadersModel[];
  public excelData: CommSummaryModel[];
  public jsonData: any;
  public totResData: any;
  public totResData1: any;
  public totResData2: any;
  public compareDispute: any;
  public finalResponseData: any;
  public totalstatus: number;
  public tot1: any;
  public disputeMsg: string;

  public dscempid: any;
  public dcorp: any;
  public dhouse: any;
  public dcust: any;
  public dtrackid: any;
  public dkomffeedid: any;
  public daccnum: any;

  public view_dscempid: any;
  public view_dcorp: any;
  public view_dhouse: any;
  public view_dcust: any;
  public view_dtrackid: any;
  public view_dkomfeedid: any;
  public view_daccnum: any;

  public showLoading: boolean;
  public showCheckBox: boolean = false;
  public isDisBtnDisabled: boolean = true;
  public calcStatus: string;
  public supervisorStatus: string;
  public btnLength: number = 1;
  public isNoDataFound: boolean = false;

  private subscriptions: Observable<CommSummaryModel[]>[] = [];
  public refreshing: boolean;
  public loggedinUser: string = '';
  public tableColumns: any;
  public displayedColumns: any;
  public responseList: ResponseData[] = [];
  public responseList1: ResponseData[] = [];
  public pageName: string = '';
  public prevPageselected: string = '';
  public searchCriteriaSet = new Set<string>();
  public contentMessage: WorkFlowMessageModel;
  public contentMsgData: any;
  public displayedData = [];
  public disputeViewData: string = "";
  public disputeViewKpiData: string = "";

  public gridName = "";
  public headderInfo = "";
  public backButton = "NA";
  public headerGroupName = "";

  public parms: string = "";
  public actualParms: string = "";
  public finalParms: string = "";
  public searchParms1: string = "";
  public searchParms: string = "";
  public searchEmpParm: string = "";
  public searchKpiIdParm: string = "";
  public searchDependentKpiIdParm: string = "";
  public searchDependentKpiIdParm1: string = "";

  public searchFromDtParm: string = null;
  public searchToDtParm: string = null;
  public searchSalesRepIdParm: string = "";

  public searchHouseParm: string = "";
  public searchCustParm: string = "";
  public searchCorpParm: string = "";

  public total1: number = 0.00;
  public total2: number = 0.00;
  public total3: number = 0.00;
  public total4: number = 0.00;
  public total5: number = 0.00;

  public showHideTd1: boolean;
  public showHideTd2: boolean;
  public showHideTd3: boolean;
  public showHideTd4: boolean;
  public showHideTd5: boolean;

  public one: string = "0.00";
  public two: string = "0.00";
  public three: string = "0.00";
  public four: string = "0.00";
  public five: string = "0.00";

  public dataKeyVal: string = "";

  public commissionable_units: number = 0;
  public charge_back_units: number = 0;
  public net_units: number = 0;
  public net_revenue: number = 0;
  public commissionable_revenue: number = 0;

  public kpiId: number = 0;
  public dependentkpiId: number = 0;

  public kpiid: any = "";
  public dependent_kpiid: any = "";
  public final_kpiid: any = "";
  public sc_emp_id: any = "";

  public corp: any = "";
  public house: any = "";
  public cust: any = "";
  public kom_feed_id: any;
  public acc_num: any;
  public mobfeedid: any;

  public sql_str: string = "";
  public header_str: string = "";
  public selectedCommPlanId: number = 0;
  public selected_CommPlanId: number = 0;
  public selectedCalRunId: string = "";
  public selected_CalRunId: string = "";
  public selected_extra_sc_emp_id: number = 0;
  public selectedextra_sc_emp_id: number = 0;
  public selected_sc_emp_id: string = "";
  public selected_sup_extra_sc_emp_id: number = 0;
  public selected_extra_comm_plan_id: number = 0;
  public selected_sup_sc_emp_id: string = "";
  public selectedsc_emp_id: string = "";
  public jsonid: any[];
  public headersArray: Array<string>;
  public isdisputeview: boolean = false;
  public isDisputeSubmitted: string = "true";

  public dataForExcel = [];
  public dataForHeadersExcel = [];

  @ViewChild('table') table: ElementRef;

  public columnsExcelData: any;
  public ordersTableExcelHeaderColumns: TableColumn[];
  public headersObj = {};
  public sortableColumn: string = "";
  public str1: string = "";
  public str2: string = "";
  public nrSelect: string = "";

  public byUser: string = "";
  public findByEmp: string = "";
  public findByDependentProductTotalScore: string = "";
  public findByProduct: string = "";
  public findByHouseCorpCust: string = "";
  public findKpiByCust: string = "";
  public findHouseCorpCustByKpi: string = "";

  public isFixedDisabled: boolean = true;
  public isMobileDisabled: boolean = false;
  public selectedMIssingDisputeVal: string = "f";

  resultForExcel = [];

  constructor(private _location: Location, private authguardService: AuthGaurdService, private globalService: GlobalService, private router: Router,
    private notificationService: NotificationService, private httpService: HttpClient,
    private route: ActivatedRoute, private commissionSummaryService: CommissionSummaryService,
    private approvalFlowService: ApprovalFlowService, private missingDisputesService: MissingDisputesService, public ete: ExportExcelService, private manageUserService: ManageUserService, private kpimasterService: KpimasterService) {
    globalService._disableBackButton();
  }

  ngOnInit(): void {
    this.nrSelect = "f";
    this.loadData();
  }

  filterData(value: any) {
    //console.log(value);
    this.selectedMIssingDisputeVal = value;
    if (value === "f") {
      this.isFixedDisabled = true;
      this.isMobileDisabled = false;
    } else {
      this.isFixedDisabled = false;
      this.isMobileDisabled = true;
    }
  }

  public loadData() {
    console.log("loadData Called");
    this.missingDisputesModel.created_by = "";
    this.missingDisputesModel.created_dt = new Date();
    this.missingModels.push(this.missingDisputesModel);

    this.commSummaryModel = this.commissionSummaryService.commSummaryModel;
    this.searchCriteriaSet = this.commissionSummaryService.searchCriteriaSet;

    if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Representative" || localStorage.getItem('CURRENT_USERROLE_SESSION') === "Supervisor") {
      this.showCheckBox = false;
      this.commSummaryModel.extra_sc_emp_id = 0;
      this.commSummaryModel.sc_emp_id = localStorage.getItem('CURRENT_SC_EMP_ID_SESSION');

      this.commSummaryModel.sup_extra_sc_emp_id = 1;
      this.commSummaryModel.sup_sc_emp_id = 'NA';
      this.commSummaryModel.extra_comm_plan_id = 0;

    } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "ADMIN") {
      this.showCheckBox = false;
      this.commSummaryModel.extra_sc_emp_id = 1;
      this.commSummaryModel.sc_emp_id = 'NA';

      this.commSummaryModel.sup_extra_sc_emp_id = 1;
      this.commSummaryModel.sup_sc_emp_id = 'NA';
      this.commSummaryModel.extra_comm_plan_id = 0;
    }

    if (this.commSummaryModel.commPlanId) {
      this.selectedCommPlanId = this.commSummaryModel.commPlanId;
    } else {
      this.selectedCommPlanId = 0;
    }

    this.selectedCalRunId = this.commSummaryModel.calRunId;
    this.selectedextra_sc_emp_id = this.commSummaryModel.extra_sc_emp_id;
    this.selectedsc_emp_id = this.commSummaryModel.sc_emp_id;

    if (this.commSummaryModel.sup_sc_emp_id === "NA") {
      this.selected_sup_extra_sc_emp_id = this.commSummaryModel.sup_extra_sc_emp_id;
      this.selected_sup_sc_emp_id = this.commSummaryModel.sup_sc_emp_id;
      this.selected_extra_comm_plan_id = this.commSummaryModel.extra_comm_plan_id;
    } else {
      this.selected_sup_extra_sc_emp_id = this.commSummaryModel.sup_extra_sc_emp_id;
      this.selected_sup_sc_emp_id = this.commSummaryModel.sup_sc_emp_id.slice(0, -2);
      this.selected_extra_comm_plan_id = this.commSummaryModel.extra_comm_plan_id;
    }

    this.searchParms1 = this.selectedCalRunId + "," + this.selected_extra_comm_plan_id + "," + this.selectedCommPlanId + "," + this.selectedextra_sc_emp_id + "," + this.selectedsc_emp_id;
    this.searchParms = this.selectedCalRunId + "," + this.selectedCommPlanId;
    this.route.queryParams.subscribe(params => {
      this.pageName = params['page'];
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
    if (this.pageName === "ListUsers" || this.pageName === "ByCustomer") {
      if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Supervisor") {
        this.showCheckBox = true;
      } else {
        this.showCheckBox = false;
      }
    } else {
      this.showCheckBox = false;
    }
    this.getHeadersAndButtons(this.selectedCommPlanId);

    if (this.pageName === "ListUsers" || this.pageName === "ByCustomer") {
      this.headderInfo = "User Details";
      this.byUser = this.headderInfo;
    }

    console.log("Page Name = " + this.pageName);

    // this.getActiveKpis();

  }



  public onClickHyperLink(resData: any, pageNav: string) {
    console.log("onClickHyperLink Called = " + JSON.stringify(resData));
    this.selectedCommPlanId = resData.comm_plan_id;
    if (this.selectedCommPlanId) {
      this.searchParms = this.selectedCalRunId + "," + this.selectedCommPlanId;
    } else {
      this.selectedCommPlanId = 0;
      this.searchParms = this.selectedCalRunId + "," + this.selectedCommPlanId;
    }

    localStorage.setItem('SESSIONS_dpndnt_kpi_id', resData.dpndnt_kpi_id);

    this.responseList1 = [];
    this.responseList = [];
    this.pageName = pageNav;



    if (this.pageName === "ListKPIs" || this.pageName === "FindByCustByEmp") {
      this.headderInfo = this.headderInfo + " -> " + resData.empname;
      this.findByEmp = this.headderInfo;
    } else if (this.pageName === "FindByDependentProductTotalScore") {
      this.headderInfo = this.headderInfo + " -> " + resData.kpiname;
      this.findByDependentProductTotalScore = this.headderInfo;
    } else if (this.pageName === "FindByProduct" || this.pageName === "FindByProductDepnt" || this.pageName === "FindByProductDepntTotal" || this.pageName === "FindByProductSup") {
      this.headderInfo = this.headderInfo + " -> " + resData.display_name;
      this.findByProduct = this.headderInfo;
    } else if (this.pageName === "FindByHouseCorpCust") {
      this.headderInfo = this.headderInfo + " -> " + resData.house;
      this.findByHouseCorpCust = this.headderInfo;
    } else if (this.pageName === "FindKpiByCust") {
      this.headderInfo = this.headderInfo + " -> " + resData.cust_name;
      this.findKpiByCust = this.headderInfo;
    } else if (this.pageName === "FindHouseCorpCustByKpi") {
      this.headderInfo = this.headderInfo + " -> " + resData.kpiname;
      this.findHouseCorpCustByKpi = this.headderInfo;
    }

    this.searchEmpParm = resData.sc_emp_id;
    if (this.searchEmpParm !== undefined) {
      localStorage.setItem("emp", this.searchEmpParm);
    }
    this.searchKpiIdParm = "," + resData.kpi_id;
    if (this.pageName === "FindByProduct" || this.pageName === "FindByProductDepnt" || this.pageName === "FindByProductDepntTotal") {
      this.searchDependentKpiIdParm1 = "," + "0";
      this.searchDependentKpiIdParm = "," + resData.dpndnt_kpi_id;
    } else {
      this.searchDependentKpiIdParm1 = "," + "1";
      this.searchDependentKpiIdParm = "," + "0";
    }

    if (resData.house !== undefined) {
      this.searchCustParm = "," + resData.cust;
      localStorage.setItem("cust1", this.searchCustParm);
      this.searchHouseParm = "," + resData.house;
      localStorage.setItem("house1", this.searchHouseParm);
      this.searchCorpParm = "," + resData.corp;
      localStorage.setItem("corp1", this.searchCorpParm);
    }
    this.kpiId = 0;
    this.dependentkpiId = 0;

    this.kpiId = resData.kpi_id;
    this.dependentkpiId = resData.dpndnt_kpi_id;

    if (this.dependentkpiId) {
      this.getPageNames(this.dependentkpiId);
    } else {
      if (this.kpiId) {
        this.getPageNames(this.kpiId);
      }
    }

    this.getHeadersAndButtons(this.selectedCommPlanId);
    this.router.navigate(['/' + this.pageName]);
  }

  getPageNames(kpiid: number) {
    this.pageNameList = [];
    this.commissionSummaryService.getPageName(this.selectedCommPlanId, kpiid).subscribe(
      (response: UploadJsonHeadersModel[]) => {
        this.pageNameList = response;
        if (this.pageNameList.length > 0) {
          this.responseList1 = [];
          this.responseList = [];
          this.actualParms = "";
          this.pageName = "";
          this.pageName = this.pageNameList[0].pageName;
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
        this.showLoading = false;
      });
  }

  getHeadersAndButtons(complanid: number) {
    console.log("getHeadersAndButtons Called");
    this.getRequiredData(complanid, this.selectedCalRunId);
  }

  getRequiredData(complanid: number, calrunid: string) {
    console.log("getRequiredData Called");
    this.commissionSummaryService.fetchHeaders(complanid,'NA','NA').subscribe(
      (response: UploadJsonHeadersModel[]) => {
        this.headersData = response;
        this.headersData1 = JSON.parse(JSON.stringify(response));
        this.commissionSummaryService.fetchButtons(complanid).subscribe(
          (response: UploadJsonHeadersModel[]) => {
            this.buttonsData = response;
            this.buttonsData1 = JSON.parse(JSON.stringify(response));

            this.fetchDataByPage();

          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
            this.showLoading = false;
          });
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
        this.showLoading = false;
      });
  }

  private fetchDataByPage() {
    console.log("fetchDataByPage Called");

    this.findParms();
    this.commissionSummaryService.fetchDataByPage(this.pageName, this.selectedCommPlanId,'NA','NA','NA').subscribe(
      (response: UploadJsonModel[]) => {
        this.gridName = "";
        this.jsonListData = response;

        for (let jsonModel of this.jsonListData) {
          this.gridName = jsonModel.gridName;
          this.runSql(this.gridName, jsonModel.id);
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
        this.showLoading = false;
      }
    )
  }



  exportResultExcel() {
    //console.log(this.excelResultReportView);
    this.dataForExcel = [];
    this.dataForHeadersExcel = [];
    let reportData = null;
    this.excelDataList.forEach((row: any) => {
      //console.log("obj === " + Object.values(row));
      this.resultForExcel.push(Object.values(row));
      this.dataForHeadersExcel.push(Object.keys(row));
    })
    // console.log(this.resultForExcel);
    reportData = {
      title: 'ReportView',
      data: this.resultForExcel,
      headers: this.dataForHeadersExcel[0]
    }
    this.ete.exportExcel(reportData);

    this.router.navigate(['/search-report-view']);
  }

  public runSql(gridName: string, id: number): void {
    console.log("runSql Called");


    this.subscriptions = [];



    console.log(this.actualParms);
    console.log(this.pageName);
    console.log(this.gridName);
    console.log(this.selectedCommPlanId);

    if (this.pageName === "CommissionDocReport") {
      console.log("Inside IF");
      this.finalParms = this.selectedCommPlanId.toString();
    } else {
      console.log("Inside ELSE");
      this.finalParms = this.actualParms;
    }

    console.log(this.finalParms);

    this.subscriptions.push(
      this.commissionSummaryService.runSqlSearch(this.finalParms, this.pageName, gridName, this.selectedCommPlanId)
    );

    forkJoin(this.subscriptions).subscribe(response => {
      this.parms = "";

      response.forEach(element => {

        console.log("element = " + JSON.stringify(element));


        this.excelData = element;
        this.finalResponseData = JSON.parse(JSON.stringify(element));
        console.log(this.finalResponseData);


        const data = new ResponseData();
        data.responsedata = this.finalResponseData;
        this.headersData1 = this.headersData.filter(item => item.jsonsqlid.toString().startsWith(id.toString()));
        this.buttonsData1 = this.buttonsData.filter(item => item.jsonsqlid.toString().startsWith(id.toString()));

        data.headers = JSON.parse(JSON.stringify(this.headersData1));
        data.buttons = JSON.parse(JSON.stringify(this.buttonsData1));

        console.log(data.headers);
        console.log(data.buttons);

        this.responseList1.push(data);
        console.log(this.responseList1);
        console.log(this.responseList1[0].responsedata);
        // this.responseList.push(this.responseList1[0]);
        // this.responseList.push(this.responseList1[1]);
        this.excelDataList = JSON.parse(JSON.stringify(this.responseList1[0].responsedata));
        this.exportResultExcel();

        //  console.log(this.responseList);
        // this.findSum();


      });

    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
      this.showLoading = false;
    });
  }


  findSum() {
    //console.log("findSum Called");
    this.total1 = 0.00;
    this.total2 = 0.00;
    this.total3 = 0.00;
    this.total4 = 0.00;
    this.total5 = 0.00;

    this.totResData = this.totResData1;

    for (let j = 0; j < this.totResData.length; j++) {
      if (this.pageName === "ListUsers" || this.pageName === "ByCustomer") {
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = true;
        this.showHideTd4 = true;
        this.showHideTd5 = true;
        this.total1 += +this.totResData[j].revenue;
        this.total2 += +this.totResData[j].commission_val;
      } else if (this.pageName === "ListKPIs") {
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = true;
        this.showHideTd4 = true;
        this.showHideTd5 = true;

        if (this.totResData[j].revenue == undefined || this.totResData[j].revenue == null || this.totResData[j].revenue == "null") {
        } else {
          this.total1 += +this.totResData[j].revenue;
        }

        if (this.totResData[j].commission_val == undefined || this.totResData[j].commission_val == null || this.totResData[j].commission_val == "null") {
        } else {
          this.total2 += +this.totResData[j].commission_val;
        }

      } else if (this.pageName === "FindByProduct" || this.pageName === "FindByProductDepnt" || this.pageName === "FindByProductDepntTotal") {
        console.log("Inside FindByProduct");
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = false;
        this.showHideTd4 = false;
        this.showHideTd5 = true;
        this.total1 += +this.totResData[j].commissionable_units;
        this.total2 += +this.totResData[j].commissionable_units;
        this.total3 += +this.totResData[j].net_revenue;
        this.total4 += +this.totResData[j].commission;
      } else if (this.pageName === "FindByProductSup") {
        console.log("Inside FindByProductSup");
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = true;
        this.showHideTd4 = true;
        this.showHideTd5 = true;
        this.total1 += +this.totResData[j].commissionable_units;
        this.total2 += +this.totResData[j].net_revenue;
      } else if (this.pageName === "FindByProductMobileLines") {
        console.log("Inside FindByProductMobileLines");
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = false;
        this.showHideTd4 = true;
        this.showHideTd5 = true;
        this.total1 += +this.totResData[j].commissionable_units;
        this.total2 += +this.totResData[j].net_revenue;
        this.total3 += +this.totResData[j].commissionable_revenue;
      } else if (this.pageName === "FindByCustByEmp") {
        console.log("Inside FindByCustByEmp");
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = true;
        this.showHideTd4 = true;
        this.showHideTd5 = true;
        this.total1 += +this.totResData[j].net_revenue;
        this.total2 += +this.totResData[j].commission;
      } else if (this.pageName === "FindKpiByCust") {
        console.log("Inside FindKpiByCust");
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = true;
        this.showHideTd4 = true;
        this.showHideTd5 = true;
        this.total1 += +this.totResData[j].commissionable_units;
        this.total2 += +this.totResData[j].commission_val;
      } else if (this.pageName === "FindByDependentProduct") {
        console.log("Inside FindByDependentProduct");
        this.showHideTd1 = false;
        this.showHideTd2 = true;
        this.showHideTd3 = true;
        this.showHideTd4 = true;
        this.showHideTd5 = true;

        this.total1 += +this.totResData[j].score_intermediate;
      } else if (this.pageName === "FindByDependentProductTotalScore") {
        console.log("Inside FindByDependentProductTotalScore");
        this.showHideTd1 = false;
        this.showHideTd2 = false;
        this.showHideTd3 = true;
        this.showHideTd4 = true;
        this.showHideTd5 = true;

        this.total1 += +this.totResData[j].commissionable_units;
        this.total2 += +this.totResData[j].revenue;
      }
    }// for close

    if (this.pageName === "ListUsers" || this.pageName === "ByCustomer") {
      this.one = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" }).format(this.total1);
      this.two = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" }).format(this.total2);
    } else if (this.pageName === "ListKPIs") {
      this.one = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" }).format(this.total1);
      this.two = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" }).format(this.total2);
    } else if (this.pageName === "FindByProduct" || this.pageName === "FindByProductDepnt" || this.pageName === "FindByProductDepntTotal") {
      this.one = this.total1.toString();
      this.two = this.total2.toString();
      this.three = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" }).format(this.total3);
      this.four = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" }).format(this.total4);
    } else if (this.pageName === "FindByProductSup") {
      this.one = this.total1.toString();
      this.two = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" }).format(this.total2);
    } else if (this.pageName === "FindByProductMobileLines") {
      this.one = this.total1.toString();
      this.two = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" }).format(this.total2);
      this.three = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" }).format(this.total3);
    } else if (this.pageName === "FindByCustByEmp") {
      this.one = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" }).format(this.total1);
      this.two = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" }).format(this.total2);
    } else if (this.pageName === "FindKpiByCust") {
      this.one = this.total1.toString();
      this.two = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" }).format(this.total2);
    } else if (this.pageName === "FindByDependentProduct") {
      this.one = Number(this.total1).toFixed(2);
    } else if (this.pageName === "FindByDependentProductTotalScore") {
      this.one = this.total1.toString();
      this.two = new Intl.NumberFormat('en-US', { style: "currency", currency: "USD" }).format(this.total2);
    }

  }

  findParms() {
    // console.log("findParms Called");
    if (this.pageName === "ListUsers" || this.pageName === "ByCustomer") {
      this.actualParms = "";
      this.actualParms = this.searchParms1 + "," + localStorage.getItem('validToDt') + "," + localStorage.getItem('validToDt');
      console.log("ListUsers ByCustomer actualParms = " + this.actualParms);
    } else if (this.pageName === "ListKPIs") {
      this.actualParms = "";
      this.actualParms = this.searchEmpParm + "," + this.searchParms + "," + localStorage.getItem('validToDt');
      console.log("ListKPIs actualParms = " + this.actualParms);
    } else if (this.pageName === "FindByDependentProduct") {
      this.actualParms = "";
      this.actualParms = this.selectedCalRunId + "," + this.searchEmpParm + this.searchKpiIdParm + "," + this.selectedCommPlanId + "," + localStorage.getItem('validToDt');
      console.log("FindByDependentProduct actualParms = " + this.actualParms);
    } else if (this.pageName === "FindByDependentProductTotalScore") {
      this.actualParms = "";
      this.actualParms = localStorage.getItem('validToDt') + "," + this.selectedCalRunId + "," + this.searchEmpParm + this.searchKpiIdParm + "," + this.selectedCommPlanId;
      console.log("FindByDependentProductTotalScore actualParms = " + this.actualParms);
    } else if (this.pageName === "FindByProduct" || this.pageName === "FindByProductDepnt" || this.pageName === "FindByProductDepntTotal" || this.pageName === "FindByProductMobileLines" || this.pageName === "FindByProductSup") {
      this.actualParms = "";
      if ((this.pageName === "FindByProduct" || this.pageName === "FindByProductDepnt" || this.pageName === "FindByProductDepntTotal" || this.pageName === "FindByProductSup") && this.backButton === "backbtn") {
        console.log(localStorage.getItem('SESSIONS_dpndnt_kpi_id'));
        if (localStorage.getItem('SESSIONS_dpndnt_kpi_id') === "null") {
          this.searchDependentKpiIdParm1 = "," + "1";
          this.searchDependentKpiIdParm = "," + "0";
        } else {
          this.searchDependentKpiIdParm1 = "," + "0";
          this.searchDependentKpiIdParm = "," + localStorage.getItem('SESSIONS_dpndnt_kpi_id');
        }
      }
      this.actualParms = this.selectedCommPlanId + "," + this.selectedCalRunId + "," + this.searchEmpParm + this.searchKpiIdParm + this.searchDependentKpiIdParm1 + this.searchDependentKpiIdParm;
      console.log("FindByProduct FindByProductMobileLines FindByProductSup actualParms = " + this.actualParms);
    } else if (this.pageName === "FindByHouseCorpCust") {
      this.actualParms = "";
      this.actualParms = this.searchFromDtParm + this.searchToDtParm + this.searchCustParm + this.searchHouseParm + this.searchCorpParm + this.searchSalesRepIdParm;
      console.log("FindByHouseCorpCust actualParms = " + this.actualParms);
    } else if (this.pageName === "FindByCustByEmp") {
      this.actualParms = "";
      this.actualParms = this.searchParms + "," + localStorage.getItem("emp") + "," + localStorage.getItem('validToDt');
      console.log("FindByCustByEmp actualParms = " + this.actualParms);
    } else if (this.pageName === "FindKpiByCust") {
      localStorage.setItem("parms", this.searchParms);
      this.actualParms = "";
      this.actualParms = localStorage.getItem("emp") + "," + localStorage.getItem("parms") + localStorage.getItem("house1") + localStorage.getItem("corp1") + localStorage.getItem("cust1") + "," + localStorage.getItem('validToDt');
      localStorage.setItem("house", this.searchHouseParm);
      localStorage.setItem("corp", this.searchCorpParm);
      localStorage.setItem("cust", this.searchCustParm);
      console.log("FindKpiByCust actualParms = " + this.actualParms);
    } else if (this.pageName === "FindHouseCorpCustByKpi") {
      this.actualParms = "";
      this.actualParms = this.searchFromDtParm + this.searchToDtParm + localStorage.getItem("cust") + localStorage.getItem("house") + localStorage.getItem("corp") + this.searchSalesRepIdParm;
      console.log("FindHouseCorpCustByKpi actualParms = " + this.actualParms);
    } else {
      this.actualParms = "";
      this.actualParms = this.searchParms;
      console.log("Else actualParms = " + this.actualParms);
    }
    //console.log("pageStatus: " + this.pageStatus);
  }

  public backBtnPage(backPageName: string, backBtn: string) {
    console.log("backBtnPage Called");
    console.log("backPageName:" + backPageName);
    console.log("backBtn:" + backBtn);

    this.backButton = backBtn;

    this.router.navigate(['/' + backPageName]);
    //this.fetchDataByPage();

  }

  roundTo(num: number, places: number) {
    const factor = 10 ** places;
    return Math.round((num + Number.EPSILON) * 100) / 100;
  };

  redirect(url: string) {
    console.log("redirect Called");
    this.router.navigate(['/' + url]);
  }

  backClicked() {
    this._location.back();
  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  public clickToCloseButton(buttonId: string, disputeForm: NgForm): void {
    document.getElementById(buttonId).click();
    disputeForm.reset();
  }

  getViewDisputeValues(resData: any) {
    console.log("getViewDisputeValues() called: " + JSON.stringify(resData));
    this.view_dscempid = resData.sc_emp_id;
    this.view_dcorp = resData.corp;
    this.view_dhouse = resData.house;
    this.view_dcust = resData.cust;
    this.view_dkomfeedid = resData.kom_feed_id;
    this.view_daccnum = resData.account_number;
    //this.view_dtrackid = this.view_dscempid + "-" + this.view_dcorp + "-" + this.view_dhouse + "-" + this.view_dcust;

    // console.log(this.view_dkomfeedid);
    // console.log(this.view_daccnum);

    if (!this.view_dkomfeedid) {
      this.view_dtrackid = this.view_daccnum;
    } else {
      this.view_dtrackid = this.view_dkomfeedid;
    }

    if (!this.view_dtrackid) {
      this.view_dtrackid = this.view_dhouse;
    }

    console.log(this.view_dtrackid);

    this.approvalFlowService.getContentMessage(this.view_dtrackid)
      .subscribe((response: WorkFlowMessageModel) => {
        this.contentMessage = response;
        console.log(JSON.stringify(this.contentMessage));

        this.contentMsgData = this.parseXmlToJson(this.contentMessage[0].message_content);
        this.displayedColumns = Object.keys(this.contentMsgData).map(k => k);
        this.displayedData = Object.values(this.contentMsgData).map(k => k);
        console.log(this.displayedData);
        //this.disputeViewData = this.displayedData.toString();
        //console.log(this.disputeViewData);
        //this.disputeViewData = this.disputeViewData.split(/[,]+/).pop();
        //console.log(this.disputeViewData);
        let j: number = 0;

        for (let msg of this.displayedData) {
          console.log("J = " + j);
          if (this.displayedData.length === 8) {
            if (j === 6) {
              this.disputeViewData = msg;
              // console.log(this.disputeViewData);
            }
            if (j === 7) {
              this.disputeViewKpiData = msg;
              // console.log(this.disputeViewKpiData);
            }
          } else {
            if (j === 10) {
              this.disputeViewKpiData = msg;
              // console.log(this.disputeViewKpiData);
            }
            if (j === 11) {
              this.disputeViewData = msg;
              // console.log(this.disputeViewData);
            }
          }

          j++;
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getAddDisputeValues(resData: any) {
    console.log("getAddDisputeValues() called" + JSON.stringify(resData));

    //console.log(resData.account_number);
    //console.log(resData.kom_feed_id);

    this.kpiid = resData.kpi_id;
    console.log(this.kpiid);
    this.dependent_kpiid = resData.dpndnt_kpi_id;
    console.log(this.dependent_kpiid);
    if (this.dependent_kpiid) {
      this.final_kpiid = this.dependent_kpiid;
    } else {
      this.final_kpiid = this.kpiid;
    }
    console.log(this.final_kpiid);
    this.sc_emp_id = resData.sc_emp_id;

    this.corp = resData.corp;
    this.house = resData.house;
    this.cust = resData.cust;
    this.kom_feed_id = resData.kom_feed_id;
    this.acc_num = resData.account_number;
    this.mobfeedid = resData.mob_feed_id;

    if (resData.account_number) {
      //console.log("mobile data");
      this.recordType = "mob";
      this.disputeMsg = "<DisputeType>Dispute-Mobile</DisputeType>" + "<FinalizedDate>-</FinalizedDate>" + "<AccountNumber>" + resData.account_number + "</AccountNumber>";

    } else if (resData.kom_feed_id) {
      // console.log("kom feed data");
      this.recordType = "fixed";
      this.disputeMsg = "<Corp>" + resData.corp + "</Corp>"
        + "<House>" + resData.house + "</House>" + "<CustomerName>" + resData.cust_name + "</CustomerName>" + "<CompasID>" + resData.sc_emp_id + "</CompasID>"
        + "<Revenue>" + resData.net_revenue + "</Revenue>" + "<WorDate>" + resData.wordate + "</WorDate>"
        + "<WfinDate>" + resData.wfindate + "</WfinDate>";
    } else {
      this.recordType = "manual";
      this.disputeMsg = "<Corp>" + resData.corp + "</Corp>"
        + "<House>" + resData.house + "</House>" + "<CustomerName>" + resData.cust_name + "</CustomerName>" + "<CompasID>" + resData.sc_emp_id + "</CompasID>"
        + "<Revenue>" + resData.net_revenue + "</Revenue>" + "<WorDate>" + resData.wordate + "</WorDate>"
        + "<WfinDate>" + resData.wfindate + "</WfinDate>";
    }
    //console.log(this.disputeMsg);
  }

  public insertDispute(disputeForm: NgForm): void {
    this.vkpiid = "";
    for (let val of this.missingModels) {
      this.vkpiid = this.vkpiid + val.kpi_id + ",";
    }
    this.vkpiid = this.vkpiid.replace(/,\s*$/, "");

    this.workFlowMessageModel.kpiid = this.vkpiid;
    //this.workFlowMessageModel.kpiid = this.kpiid;
    this.workFlowMessageModel.sc_emp_id = this.sc_emp_id;
    this.workFlowMessageModel.complanid = this.selectedCommPlanId;
    this.workFlowMessageModel.complex_kpiid = this.final_kpiid;

    this.workFlowMessageModel.corp = this.corp;
    this.workFlowMessageModel.house = this.house;
    this.workFlowMessageModel.cust = this.cust;
    this.workFlowMessageModel.kom_feed_id = this.kom_feed_id;
    this.workFlowMessageModel.accnum = this.acc_num;
    this.workFlowMessageModel.mob_feed_id = this.mobfeedid
    this.workFlowMessageModel.sales_rep_id = "NA";

    this.workFlowMessageModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.workFlowMessageModel.employee_id = localStorage.getItem('CURRENT_EMPLOYEEID_SESSION');

    if (this.recordType === "mob") {
      this.workFlowMessageModel.message_content = this.disputeMsg + "<Message>" + this.workFlowMessageModel.dispute + "</Message>" + "<KPIID>" + this.workFlowMessageModel.kpiid + "</KPIID>";
    } else if (this.recordType === "fixed") {
      this.workFlowMessageModel.message_content = this.disputeMsg + "<KPIID>" + this.workFlowMessageModel.kpiid + "</KPIID>" + "<Message>" + this.workFlowMessageModel.dispute + "</Message>" + "<DisputeType>Dispute-Fixed Lines</DisputeType>";
    } else if (this.recordType === "manual") {
      this.workFlowMessageModel.message_content = this.disputeMsg + "<KPIID>" + this.workFlowMessageModel.kpiid + "</KPIID>" + "<Message>" + this.workFlowMessageModel.dispute + "</Message>" + "<DisputeType>Dispute-Fixed Lines-Manual</DisputeType>";
    }

    this.workFlowMessageModel.recordType = this.recordType;

    this.commissionSummaryService.insertDispute(this.workFlowMessageModel).subscribe(
      (response: WorkFlowMessageModel) => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, "Inserted Successfully\nTicket Created");
        //this.notificationService.sendNotification(NotificationType.SUCCESS, "Ticket Created");
        this.responseList1 = [];
        this.responseList = [];
        this.fetchDataByPage();
        this.clickButton('closeAddButton');
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )

  }

  public insertMissingDispute(kpiForm: NgForm): void {
    this.vkpiid = "";
    for (let val of this.missingModels) {
      this.vkpiid = this.vkpiid + val.kpi_id + ",";
    }

    // console.log(this.vkpiid);
    this.vkpiid = this.vkpiid.replace(/,\s*$/, "");
    // console.log(this.vkpiid);
    kpiForm.value.kpi_id = this.vkpiid;
    kpiForm.value.message = this.missingDisputesModel.message;
    kpiForm.value.sc_emp_id = this.searchEmpParm;
    kpiForm.value.calRunId = this.selectedCalRunId;

    this.showLoading = true;
    const formData = this.missingDisputesService.createMissingForm(kpiForm.value);

    this.workFlowMessageModel.kpiid = this.vkpiid;
    this.workFlowMessageModel.sc_emp_id = this.searchEmpParm;
    this.workFlowMessageModel.calRunId = this.selectedCalRunId;

    this.workFlowMessageModel.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    this.workFlowMessageModel.employee_id = localStorage.getItem('CURRENT_EMPLOYEEID_SESSION');

    this.workFlowMessageModel.corp = this.missingDisputesModel.corp;
    this.workFlowMessageModel.house = this.missingDisputesModel.house;
    this.workFlowMessageModel.cust = this.missingDisputesModel.cust_id;
    this.workFlowMessageModel.finalizeddate = this.missingDisputesModel.finalizeddate;
    this.workFlowMessageModel.accnumber = this.missingDisputesModel.accnumber;

    //console.log(this.selectedMIssingDisputeVal);

    if (this.selectedMIssingDisputeVal === "f") {
      //Feed
      this.disputeMsg = "<Corp>" + this.missingDisputesModel.corp + "</Corp>"
        + "<House>" + this.missingDisputesModel.house + "</House>" + "<CustomerName>" + this.missingDisputesModel.cust_id + "</CustomerName>" +
        "<DisputeType>Missing Transaction-Fixed Lines</DisputeType>" + "<FinalizedDate>" + this.missingDisputesModel.finalizeddate + "</FinalizedDate>" + "<AccountNumber>-</AccountNumber>" + "<Message>" + this.missingDisputesModel.message + "</Message>" + "<KPIID>" + this.workFlowMessageModel.kpiid + "</KPIID>";
    } else {
      //Mobile
      this.disputeMsg = "<DisputeType>Missing Transaction-Mobile</DisputeType>" + "<FinalizedDate>-</FinalizedDate>" + "<AccountNumber>" + this.missingDisputesModel.accnumber + "</AccountNumber>" + "<Message>" + this.missingDisputesModel.message + "</Message>" + "<KPIID>" + this.workFlowMessageModel.kpiid + "</KPIID>";
    }

    this.workFlowMessageModel.message_content = this.disputeMsg;

    this.missingDisputesService.insertMissingDisputeStatic(this.missingDisputesModel).subscribe(
      (response: CustomHttpRespone) => {
        this.clickButton('closeAddButton');
        this.insertDisputeMsg();
        kpiForm.reset();
        this.vkpiid = "";
        this.missingModels = [];
        this.missingDisputesModel.created_by = "";
        this.missingDisputesModel.created_dt = new Date();
        this.missingModels.push(this.missingDisputesModel);
        this.showLoading = false;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
        this.showLoading = false;
      }
    )
  }

  public insertDisputeMsg(): void {
    // console.log(this.workFlowMessageModel);
    this.commissionSummaryService.insertDisputeStatic(this.workFlowMessageModel).subscribe(
      (response: WorkFlowMessageModel) => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, "Inserted Successfully. Ticket Created");
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public getActiveKpis(): void {

    this.commissionSummaryService.getKpiActiveList(this.selectedCommPlanId, localStorage.getItem('validToDt')).subscribe(
      (response: Kpimaster[]) => {
        this.kpis = response;
        this.filterKPiData = this.kpis;
        // filter active kpis
        //const filterValue = this.globalService._normalizeValue('Active');
        //this.filterKPiData = this.kpis.filter(comm => this.globalService._normalizeValue(comm.kpi_status).startsWith(filterValue));
        // this.kpisData = this.filterKPiData;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  hideRemainingLabels(id: number): boolean {
    if (id === 0)
      return true;
    else
      return false;
  }

  addNewRow(missingForm: NgForm) {
    const kpiObj = new MissingDisputesModel();
    kpiObj.kpi_id = this.missingDisputesModel1.kpi_id;
    kpiObj.comm_plan_id = this.missingDisputesModel1.comm_plan_id;
    this.missingModels.push(kpiObj);
  }

  public removeRow(index: any) {
    if (this.missingModels.length > 1) {
      if (this.missingModels[index].kpi_id != null) {
        this.removeFilterData(index);
      } else {
        this.removeFilterData(index);
        //this.kpiModels.splice(index, 1);
      }
    } else {
      this.notificationService.sendNotification(NotificationType.WARNING, "There Is Only One Row Exist You Can't Delete.");
    }
  }

  private removeFilterData(i: any) {

    if (this.missingModels.length > 0) {
      const compos = this.missingModels[i].kpi_id;
      this.missingModels.forEach((value: any, index: any) => {
        if (value.kpi_id == compos)
          this.missingModels.splice(index, 1);
      })
    }
  }

  parseXmlToJson(xml) {
    const json = {};
    for (const res of xml.matchAll(/(?:<(\w*)(?:\s[^>]*)*>)((?:(?!<\1).)*)(?:<\/\1>)|<(\w*)(?:\s*)*\/>/gm)) {
      const key = res[1] || res[3];
      const value = res[2] && this.parseXmlToJson(res[2]);
      json[key] = ((value && Object.keys(value).length) ? value : res[2]) || null;

    }
    return json;
  }

  public ExportTOExcel() {
    this.ete.exportFromHtmlTable(this.table.nativeElement, 'ReviewCommissions');
  }



  ExportTOExcel1() {
    for (let js of this.excelData) {

      delete js.comm_plan_id;
      delete js.sc_emp_id;
      delete js.effective_date;

    }
    this.dataForExcel = [];
    let reportData = null;
    this.excelData.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row))
    })
    reportData = {
      title: 'ReviewCommissions',
      data: this.dataForExcel,
      headers: Object.keys(this.headersObj)
    }
    this.ete.exportExcel(reportData);
  }

  printData() {
    window.print();
  }

  printComponent(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  }

  sort(colName) {

    this.str1 = colName;

    if (this.str1 === this.str2) {
      if (this.pageName === "ListKPIs") {
        this.responseList[1].responsedata.sort((a: any, b: any) => a[colName] < b[colName] ? -1 : 1);
      } else {
        this.responseList[0].responsedata.sort((a: any, b: any) => a[colName] < b[colName] ? -1 : 1);
      }
      this.str2 = "";
      this.str1 = "";
    } else {
      if (this.pageName === "ListKPIs") {
        this.responseList[1].responsedata.sort((a: any, b: any) => a[colName] > b[colName] ? -1 : 1);
      } else {
        this.responseList[0].responsedata.sort((a: any, b: any) => a[colName] > b[colName] ? -1 : 1);
      }
      this.str2 = this.str1;
      this.str1 = "";
    }
  }

  addMissingDispute(btn: any) {
    this.clickButton(btn);
  }

  checkedVal(value: any) {
    this.responseList1 = [];
    this.responseList = [];
    if (value.currentTarget.checked) {
      this.checkedactive = true;
      this.commSummaryModel.checkboxstatus = true;
      this.loadData();
    } else {
      this.checkedactive = false;
      this.commSummaryModel.checkboxstatus = false;
      this.loadData();
    }
  }

  noDataFound() {
    this.isNoDataFound = false;
    console.log("noDataFound called");

    this.router.navigate(['/search-comm-plan']);

    // if (this.supervisorStatus >= "20") {
    //   this.router.navigate(['/search-comm-plan-sup']);
    // } else {
    //   this.router.navigate(['/search-comm-plan']);
    // }
  }

}
